import { Content, ContentHeader, Table, TableBody, TableCell, TableHead, TableRow, Typography } from 'src/app/components'
import { useState } from 'react'
import dayjs from 'dayjs'
import { SalesPromoResultItem } from 'src/app/modules/campaign/models/SalesPromo.model'
import { SALES_PROMO_RESULT_ITEMS, SALES_PROMO_RESULT_ITEMS_ARRAY } from '../SalesPromoDetailTabResult.hook';
import { formatPhonePlustoZero } from 'src/app/utils/string-utils';

export interface TablePrizeRewardsProps {
  table?: { type: SALES_PROMO_RESULT_ITEMS, data?: SalesPromoResultItem[] }
}

function translateResultTypeSalesPromo(type?: string) {
  if (!type) return '';
  return SALES_PROMO_RESULT_ITEMS_ARRAY.find(item => item.value === type)?.label
}

export default function TablePrizesResult({ table }: TablePrizeRewardsProps) {
  const [limit, setLimit] = useState(20)
  const stickyClass = "sticky top-0 z-10 bg-white"

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;
    if (scrollHeight - scrollTop <= clientHeight + 50) {
      setLimit(prev => prev + 20);
    }
  }
  function filterRowBody(item: SalesPromoResultItem, index: number) {
    return [
      ...(table?.type !== 'point' ? [
        <TableCell key={`${index}-name`} value={item?.name} />,
        <TableCell key={`${index}-quantity`} value={item?.quantity} />
      ] : []),
      <TableCell key={`${index}-member_code`} value={item?.member_code} />,
      <TableCell key={`${index}-fullname`} value={item?.fullname} />,
      ...(table?.type === 'point' ? [
        <TableCell key={`${index}-quantity`} value={item?.quantity} />
      ] : []),
    ].filter(Boolean)
  }

  const renderItem = (item: SalesPromoResultItem, index: number) => {
    return (
      <TableRow key={`${item.name}-${index}`}>
        <TableCell {...{ index }} />
        {filterRowBody(item, index)}
        <TableCell value={item?.phone_number} renderValue={(_) => (_) ? formatPhonePlustoZero(_) : undefined} />
        <TableCell value={item?.email} />
        <TableCell
          renderValue={(_) => dayjs(_).format('DD/MM/YYYY')}
          className="w-[145px]"
          value={item?.claimed_at}
        />
        <TableCell value={item?.directory_name} />
      </TableRow>
    )
  }

  function filterRowHead() {
    return [
      ...(table?.type !== 'point' ? [
        <TableCell key="th-name" className={stickyClass}>Voucher Name</TableCell>,
        <TableCell key="th-quantity" className={stickyClass}>Qty</TableCell>
      ] : []),
      <TableCell key="th-member_code" className={stickyClass}>Customer ID</TableCell>,
      <TableCell key="th-fullname" className={stickyClass}>Customer Name</TableCell>,
      ...(table?.type === 'point' ? [
        <TableCell key="th-quantity2" className={stickyClass}>Total Point</TableCell>
      ] : []),
    ];
  }


  return (
    <Content>
      <ContentHeader title={translateResultTypeSalesPromo(table?.type) || ''} />
      {table?.data ?
        <div className="px-8">
          <div className="max-h-[60vh] overflow-y-auto relative" onScroll={handleScroll}>
            <Table classNames={{ container: "overflow-visible" }}>
              <TableHead>
                <TableRow>
                  <TableCell index className={stickyClass} />
                  {filterRowHead()}
                  <TableCell key="th-phone" className={stickyClass}>Phone Number</TableCell>
                  <TableCell key="th-email" className={stickyClass}>Email</TableCell>
                  <TableCell key="th-claimdate" className={stickyClass}>Claim Date</TableCell>
                  <TableCell key="th-claimlocation" className={stickyClass}>Claim Location</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {table?.data?.slice(0, limit).map(renderItem)}
              </TableBody>
            </Table>
          </div>
        </div> :
        <Typography variant="h4" className="font-bold h-[112px] flex items-center justify-center">{`List ${translateResultTypeSalesPromo(table?.type) || ''} is Empty`}</Typography>
      }
    </Content>
  )
}
